import httpService from './httpService'

const serverPath = window.location.origin
const arsmoApi = '/arsmo_api'

const trentmentService = {
  getTrentment: (params) => {
    const url = `${serverPath}${arsmoApi}/treatments`
    return httpService.httpGet(url, params)
  },
}

export default trentmentService



// WEBPACK FOOTER //
// ./src/services/trentment-service.js